import { Injectable } from '@angular/core';
import host from '@elliemae/em-ssf-guest';

@Injectable({
  providedIn: 'root'
})
export class HostConnectionService {

  private _transactionObject: any = null;
  private _application: any = null;
  private TransactionTemplateObject: any = null;

  private _originExpiry: Date | null = null;
  private _originContext: any = null;

  transactionRequest = {
    request: {
      type: 'NEW_REQUEST',
      options: null,
      resources: [
        {
          id: 'A_RESOURCE_ID',
          name: 'A_RESOURCE_NAME',
          mimeType: 'A_RESOURCE_MIMETYPE'
        }
      ]
    }
  };

  private transactionId: string = "";
  setTransactionId(id: string) {
    this.transactionId = id;
  }
  getTransactionId(): string {
    return this.transactionId;
  }


  constructor() {

  }

  async initializeHost() {
    console.log('initializeHost before host connection ready: ');
    host.connect();
    console.log('initializeHost', host);
    host.ready();
    console.log('ready');
    this._transactionObject = await host.getObject('transaction');
    this._application = await host.getObject('application');
    console.log('host TransactionObject: ', this._transactionObject);
    console.log('host _application: ', this._application);
  }

  async getTransactionOrigin() {

    const timeoutPromise = new Promise<never>((_, reject) =>
      setTimeout(() => reject(new Error('Authentication token request timed out.')), 5000)
    );

    const bufferTime = 290 * 1000;
    const currentTime = new Date();

    if (!this._originContext) {
      this._originContext = await Promise.race([
        this._transactionObject.getOrigin(),
        timeoutPromise
      ]);
    }
    else if (this._originExpiry && currentTime > this._originExpiry)
      this._originContext = await this._transactionObject.refreshOrigin();

    this._originExpiry = new Date(new Date().getTime() + bufferTime);
    return this._originContext;
  }

  async createTransaction(request: any) {
    const bufferTime = 290 * 1000;
    const currentTime = new Date();
    if (this._originExpiry && currentTime > this._originExpiry)
      this._originContext = await this._transactionObject.refreshOrigin();

    this._originExpiry = new Date(new Date().getTime() + bufferTime);
    return await this._transactionObject.create(request);
  }

  async setCurrentTransactionContext(transactionId: string) {
    try {
      this._transactionObject = await host.getObject('transaction');
      const transactionData = await this._transactionObject.set({ "id": transactionId });
      this.setTransactionId(transactionData.id);
    } catch (error) {
      console.log({ error })
    }
  }

  async updateTransaction(request: any, transactionId: string) {
    const bufferTime = 290 * 1000;
    const currentTime = new Date();
    if (this._originExpiry && currentTime > this._originExpiry)
      this._originContext = await this._transactionObject.refreshOrigin();

    this._originExpiry = new Date(new Date().getTime() + bufferTime);
    await this.setCurrentTransactionContext(transactionId);
    this._transactionObject = await host.getObject('transaction');
    return await this._transactionObject.update(request);
  }

  async close() {
    if (this._transactionObject) {
      return await this._transactionObject.close();
    } else {
      return await this.closeTemplate();
    }
  }

  async getApplicationCapabilities() {
    return await this._application.getCapabilities();
  }

  async openResource(resourceReference: any) {
    await this._application.open(resourceReference);
  }

  async createResource(selectedResource: any) {
    try {
      const resourceData = await this._transactionObject.createResource({ name: selectedResource.name });
      const result = await fetch(resourceData.location, {
        method: 'PUT',
        headers: {
          'Content-Type': selectedResource.type,
          'Authorization': resourceData.authorizationHeader
        },
        body: selectedResource
      });
      console.log('Stream the file to the resource location: ', { result });
    } catch (error: any) {
      console.log('Error occurred while creating resource: ', { error });
    }
  }

  async openResourceInModal(resourceReference: any) {
    await this._application.openModal(resourceReference);
  }

  async openLoginForm() {
    return await this.performAction("updateCredentials");
  }

  async openEFolderForm() {
    return await this.performAction("getAvailableResources");
  }

  async openRolesForm() {
    return await this.performAction("getRoles");
  }

  async openPersonasForm() {
    return await this.performAction("getPersonas");
  }

  async openEligibleServiceSetupsForm() {
    return await this.performAction("getEligibleServiceSetups");
  }

  async openSetContextForm() {
    return await this.performAction("setContext");
  }

  async openGetContextForm() {
    return await this.performAction("getContext");
  }

  async performAction(action: any) {
    return await this._application.performAction(action);
  }

  async supportsAction(action: any) {
    return await this._application.supportsAction(action);
  }

  async refreshOrigin() {
    return await this._transactionObject.refreshOrigin();
  }


  async initializeHostWithTransactionTemplate() {
    console.log('initializeHost before host connection ready: ');
    host.connect();
    console.log('initializeHost', host);
    host.ready();
    console.log('ready');
    this.TransactionTemplateObject = await host.getObject('transactionTemplate');
    this._application = await host.getObject('application');
    console.log('host TransactionTemplateObject: ', this.TransactionTemplateObject);
    console.log('host _application: ', this._application);
  }

  async getTransactionTemplate() {
    return await this.TransactionTemplateObject.get();
  }

  async saveTemplate(transactionTemplate: any) {
    return await this.TransactionTemplateObject.save(transactionTemplate);
  }

  async updateTemplate(transactionTemplate: any) {
    return await this.TransactionTemplateObject.update(transactionTemplate);
  }

  async closeTemplate() {
    return await this.TransactionTemplateObject.close();
  }

  //async getHost() {
  //  return await host.getHost();
  //}

  async getHost(): Promise<any> {
    //if (!this.host) {
    //  this.host = await (window as any).SSFHostConnection.connect();
    //}
    return host;
  }
}
